<template>
	<div>
		<Card>
			<transition name="fade">
				<Row v-if="mainTable.sarchCardShow" :gutter="16">
					<Col span="24">
					<search-card :form="mainTable.searchForm" :table-load-event="getRechargeFeeRateTableRecords"
						:table-search="mainTable.tableSearch" />
					</Col>
				</Row>
			</transition>
			<Row :gutter="16">
				<Col span="24">
				<div class="global-tool-bar">
					<div class="left-bar">
						<span class="title">充值方式手续费费率修改记录列表</span>
					</div>
					<div class="right-bar">
						<Button type="primary" size="small" class="btns" shape="circle" icon="ios-search"
							@click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
					</div>
				</div>
				</Col>
			</Row>

			<Row :gutter="16">
				<Col span="24">
				<stand-pagination-table :columns="mainTable.columns" :data="mainTable.data" :loading="mainTable.loading"
					:table-search="mainTable.tableSearch" :table-load-event="getRechargeFeeRateTableRecords" />
				</Col>
			</Row>

		</Card>
	</div>
</template>

<script>
import search from '@/libs/search';
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import {
    dateTimeRender
} from '@/libs/tableRowTimeRender';
import {
    formatPayType,
    getPayTypeOptions,
    PAY_TYPE_MANUAL
} from '../bank-record/BankRecordStatus';
import {
    getBandServiceFeeRateRecordList
} from '@/api/modules/finance-management/recharge-fee-rate';
export default {
    name: 'RechargeFeeRateRecordList',
    components: {
        StandPaginationTable,
        SearchCard
    },
    data() {
        return {
            mainTable: {
                columns: [{
                    title: "充值方式",
                    key: "recordPaidType",
                    align: "center",
                    render: (h, params) => {
                        return h('div', [
                            h('span', {}, formatPayType(params.row.recordPaidType))
                        ]);
                    }
                },
                {
                    title: "修改前手续费费率(%)",
                    key: "rateValueBefore",
                    align: "center"
                },
                {
                    title: "修改后手续费费率(%)",
                    key: "rateValue",
                    align: "center"
                },
                {
                    title: "修改时间",
                    key: "modifyTime",
                    align: "center",
                    render: (h, params) => dateTimeRender(h, params.row.modifyTime)
                },
                {
                    title: "修改人账号",
                    key: "userName",
                    align: "center"
                },
                {
                    title: "修改人",
                    key: "userPersonName",
                    align: "center"
                },
                {
                    title: "修改人手机号",
                    key: "userPhone",
                    align: "center"
                }
                ],
                data: [],
                loading: false,
                searchForm: [{
                    label: '充值方式',
                    type: 'Select',
                    value: [],
                    name: 'recordPaidType',
                    sql: 'in',
                    options: getPayTypeOptions()
                },
                {
                    label: '修改人',
                    type: 'Input',
                    value: '',
                    name: 'userPersonName',
                    sql: 'like'
                },
                {
                    label: '修改时间',
                    type: 'Daterange',
                    value: [],
                    name: 'modifyTime',
                    sql: 'dateBetween'
                }
                ],
                sarchCardShow: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    mounted() {
        this.getRechargeFeeRateTableRecords();
    },
    methods: {
        getRechargeFeeRateTableRecords(reset = false) {
            this.mainTable.loading = true;
            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            getBandServiceFeeRateRecordList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }
                this.mainTable.loading = false;
            }).catch(() => {
                this.mainTable.loading = false;
            });
        }
    }
};
</script>

<style>
</style>